import { defineMessages } from 'react-intl';

export const classInfoMessages = defineMessages({
  duration: {
    id: 'yield-management.schedule-detail.class-info.duration',
    defaultMessage: '{duration, number} min',
  },
  durationAndInstructor: {
    id: 'yield-management.schedule-detail.class-info.duration-and-instructor',
    defaultMessage: '{duration, number} min • {instructorName}',
  },
  isCancelled: {
    id: 'yield-management.schedule-detail.class-info.is-canceled',
    defaultMessage: 'Canceled',
  },
  isDisabled: {
    id: 'yield-management.schedule-detail.class-info.is-disabled',
    defaultMessage: 'Disabled',
  },
  reservationsStopped: {
    id: 'yield-management.schedule-detail.class-info.is-full',
    defaultMessage: 'Bookings Paused',
  },
  startTime: {
    id: 'yield-management.schedule-detail.class-info.start-time',
    defaultMessage: '{startDateTime, date, time}',
  },
});

export const headerMobileMessages = defineMessages({
  timeAndDate: {
    id: 'yield-management.schedule-detail.header-mobile',
    defaultMessage: '{dateTime, date, time} • {relative}, {dateTime, date, medium-no-year}',
  },
});

export const reservationsOverviewMessages = {
  ...defineMessages({
    soldOut: {
      id: 'yield-management.schedule-detail.reservations-overview.sold-out',
      defaultMessage: 'Spots Full',
    },
    almostSoldOut: {
      id: 'yield-management.schedule-detail.reservations-overview.almost-sold-out',
      defaultMessage: 'Almost Full',
    },
    opportunityButton: {
      id: 'yield-management.schedule-detail.reservations-overview.opportunity-button',
      defaultMessage: 'Add {recommendation, plural, one {# Spot} other {# Spots}}',
    },
    allBookings: {
      id: 'yield-management.schedule-detail.reservations-overview.all-bookings',
      defaultMessage: 'All Bookings',
    },
    of: {
      id: 'yield-management.schedule-detail.reservations-overview.of',
      defaultMessage: 'of',
    },
    xofy: {
      id: 'yield-management.schedule-detail.reservations-overview.x-of-y',
      defaultMessage: '<span>{x, number}</span><muted>of</muted><muted>{y, number}</muted>',
    },
    bookingsPaused: {
      id: 'yield-management.schedule-detail.reservations-overview.bookings-paused',
      defaultMessage: 'Network spots cannot be changed while bookings are paused',
    },
  }),
  ss: defineMessages({
    on: {
      id: 'smart-spot-toggle.on',
      defaultMessage: 'SmartSpot is ON for this class',
    },
    off: {
      id: 'smart-spot-toggle.off',
      defaultMessage: 'SmartSpot is OFF for this class',
    },
    ssAddSpotButton: {
      id: 'yield-management.schedule-detail.reservations-overview.ss-add-spot-button',
      defaultMessage: 'Add 1 Spot',
    },
  }),
  cp: defineMessages({
    short: {
      id: 'yield-management.schedule-detail.reservations-overview.cp.short',
      defaultMessage: 'ClassPass',
    },
    long: {
      id: 'yield-management.schedule-detail.reservations-overview.cp.long',
      defaultMessage: 'CP Bookings',
    },
    spots: {
      id: 'yield-management.schedule-detail.reservations-overview.cp.spots',
      defaultMessage: 'CP Spots',
    },
  }),
};

export const networkCapRecurrenceModalMessages = defineMessages({
  setCapTo: {
    id: 'yield-management.schedule-detail.network-cap-recurrence-modal.set-cap-to',
    defaultMessage: 'Set network allocation to {networkCap, number} for:',
  },
  thisInstance: {
    id: 'yield-management.schedule-detail.network-cap-recurrence-modal.this-instance',
    defaultMessage: 'This instance only',
  },
  futureInstances: {
    id: 'yield-management.schedule-detail.network-cap-recurrence-modal.future-instances',
    defaultMessage: 'This instance and all upcoming {startDateTime, date, dow-time} instances',
  },
  cancel: {
    id: 'yield-management.schedule-detail.network-cap-recurrence-modal.cancel',
    defaultMessage: 'Cancel',
  },
  update: {
    id: 'yield-management.schedule-detail.network-cap-recurrence-modal.update',
    defaultMessage: 'Update',
  },
  redirectToManageSchedule: {
    id: 'yield-management.schedule-detail.network-cap-recurrence-modal.redirect-to-manage-schedule',
    defaultMessage: 'To make changes to all future instances of this session <a>edit the session schedule</a>.',
  },
});

export const actionsMessages = defineMessages({
  editInstructor: {
    id: 'yield-management.schedule-detail.actions.edit-instructor',
    defaultMessage: 'Edit staff',
  },
  emailAll: {
    id: 'yield-management.schedule-detail.actions.email-all',
    defaultMessage: 'Email class',
  },
  emailNew: {
    id: 'yield-management.schedule-detail.actions.email-new',
    defaultMessage: 'Email new users',
  },
  cancelSingle: {
    id: 'yield-management.schedule-detail.actions.cancel-single',
    defaultMessage: 'Cancel this class',
  },
  cancelRecurring: {
    id: 'yield-management.schedule-detail.actions.cancel-recurring',
    defaultMessage: 'Cancel all future instances of this class',
  },
  stopReservations: {
    id: 'yield-management.schedule-detail.actions.stop-reservations',
    defaultMessage: 'Pause all bookings (class is full)',
  },
  allowReservations: {
    id: 'yield-management.schedule-detail.actions.allow-reservations',
    defaultMessage: 'Allow bookings (class is not full)',
  },
  options: {
    id: 'yield-management.schedule-detail.actions.options',
    defaultMessage: 'Options',
  },
  manageClass: {
    id: 'yield-management.schedule-detail.actions.manage-class',
    defaultMessage: 'Manage class',
  },
  newReservationsTitle: {
    id: 'yield-management.email-class-modal.new-reservations-title',
    defaultMessage: 'Email new users',
  },
  subjectContent: {
    id: 'yield-management.email-class-modal.subject-content',
    defaultMessage:
      'Update regarding your {startDateTime, date, time}, {startDateTime, date, long-w-dow} class at {venueNameSubtitle}',
  },
  toContent: {
    id: 'yield-management.email-class-modal.to-content',
    defaultMessage: '{reservations, plural, one {# guest} other {# guests}}',
  },
  toTitle: {
    id: 'yield-management.email-class-modal.title',
    defaultMessage: 'Email class',
  },
});
